import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import { CreateTaskRequestDto } from "../models/ClickUp/createTaskRequestDto";
import { SuccessDto } from "../models/success-dto";

@Injectable({
  providedIn: "root",
})
export class ClickUpService {
  constructor(private http: HttpClient) {}

  createTask(createTask: CreateTaskRequestDto): Observable<SuccessDto | null> {
    return this.http.post<SuccessDto | null>(
      `${environment.APP_PORT + Constants.CLICKUP}`,
      createTask
    );
  }
}
